module.exports = __webpack_public_path__ + "img/map_Z4.7.A.02.ea69c004.svg";